import {useEffect, useState} from 'react';

// Returns the component mounted state. Avoids setting state on server side and inside async code
function useMounted() {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
    return () => {
      setMounted(false)
    }
  }, [])

  return mounted
}

export default useMounted
